import { useFullShort } from './shortContentQueries';
import { useVideoPlayerConfig } from '../video/videoHooks';
export const useShortVideo = ({
  shortId,
  skip
}) => {
  const {
    short
  } = useFullShort(shortId, skip);
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  if (!short) return null;
  const {
    reference,
    hubId,
    duration
  } = short;
  return {
    videoId: reference || '',
    autoPlay,
    playSpeed,
    creatorHubId: hubId,
    creatorRegion: short.contentHublet,
    businessObjectives: short.businessObjectives,
    useCases: short.useCases,
    videoDuration: duration,
    visibility: short.visibility
  };
};